<template>
  <div :class="$style.root">
    <div :class="$style.inner" />
  </div>
</template>

<style lang="scss" module>
@use '../shared' as tableSharedStyles;

.root {
  position: relative;
  display: flex;
  padding: 6px;
  height: 40px;
  box-sizing: border-box;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-right: 1px solid tableSharedStyles.$border-color;
    z-index: tableSharedStyles.$z-index-border;
    pointer-events: none;
  }
}

.inner {
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
  background: #f5f5f5;
  border-radius: 4px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;

    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    animation: wave 1.5s linear 0.5s infinite;
  }
}

@keyframes wave {
  0% {
    transform: translate(-100%);
  }

  to {
    transform: translate(100%);
  }
}
</style>
